module.exports = __webpack_public_path__ + "img/greeting.6df14a5e.png";